import styled from 'styled-components';
import { palette, theme } from 'styled-tools';

export const Field = styled.div`
  min-height: 38px;
  margin-bottom: ${(properties) => properties.marginBottom || '10px'};
  width: 100%;
  position: relative;
  input#customFormatLabel {
    border: ${(properties) =>
      properties.error !== '' ? 'red solid 1px' : 'inherit'};
  }
`;

export const RelativeContainer = styled.div`
  width: 100%;
  position: relative;
  margin-top: ${(properties) => properties.mt ?? 10}px;
  margin-bottom: 10px;
  display: flex;

  span {
    padding: 0 10px;
    display: block;
    margin: auto 0;

    svg {
      color: gray;
      margin-bottom: -3px;
    }
  }
`;

export const FloatButton = styled.button`
  margin-left: auto;
  margin-top: auto;
  margin-bottom: auto;
  font-weight: bolder;
  border: none;
  background: none;
  color: ${(properties) => properties.color || palette('colorBody')};
  cursor: pointer;
  font-size: ${(properties) => properties.fontSize ?? 1.2}rem;
  z-index: ${(properties) => properties.zIndex || 0};
  display: flex;
  align-items: center;
  ${(properties) =>
    properties.forInput && 'position: absolute; top: 0; height:38px; right:0'};
`;

export const SetVotesWrapper = styled.div`
  display: inline-block;
  border: 1px solid ${palette('borderInput')};
  padding: 4px;
  height: 38px;
  margin-left: 10px;
  background: ${palette('bgInput')};
  font-size: 1.2rem;
  border-radius: ${theme('borderRadius.sm')};
  cursor: pointer;
  vertical-align: bottom;
  span {
    color: ${palette('colorInput')};
  }

  button {
    cursor: pointer;
    border: none;
    background: inherit;
    color: ${palette('colorInput')};
    font-size: 1.2rem;
    font-weight: bold;

    svg {
      padding-top: 5px;
    }
  }
`;
